import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Alert
} from "@mui/material";

import { stockService } from "../service/CreateStockService";

const FindBike = () => {

  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const [engine, setEngine] = useState("");
  const [chasis, setChasis] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // 🚀 FETCH ALL AVAILABLE STOCK
  const fetchStock = async () => {
    try {
      setLoading(true);

      const res = await stockService.getAvailableStock();

      let finalData = [];
      res.data?.forEach((loc) => {
        loc.bikes.forEach((bike) => finalData.push(bike));
      });

      setData(finalData);
      setFiltered(finalData);

    } catch (err) {
      setError("Failed to load bikes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStock();
  }, []);

  // 🔍 FILTER LOGIC (LIVE)
  useEffect(() => {
    let result = data;

    if (engine) {
      result = result.filter((bike) =>
        bike.engine?.toLowerCase().includes(engine.toLowerCase())
      );
    }

    if (chasis) {
      result = result.filter((bike) =>
        bike.chasis?.toLowerCase().includes(chasis.toLowerCase())
      );
    }

    setFiltered(result);
  }, [engine, chasis, data]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Find Bike / Available Stock
      </Typography>

      {/* 🔍 SEARCH */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">

          <Grid item xs={12} md={5}>
            <TextField
              label="Search Engine Number"
              fullWidth
              size="small"
              value={engine}
              onChange={(e) => setEngine(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={5}>
            <TextField
              label="Search Chasis Number"
              fullWidth
              size="small"
              value={chasis}
              onChange={(e) => setChasis(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <TextField
              label="Total"
              fullWidth
              size="small"
              value={filtered.length}
              disabled
            />
          </Grid>

        </Grid>
      </Paper>

      {/* 🔄 Loading */}
      {loading && <CircularProgress />}

      {/* ❌ Error */}
      {error && <Alert severity="error">{error}</Alert>}

      {/* 📊 TABLE */}
      {!loading && (
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Model</TableCell>
                <TableCell>Engine</TableCell>
                <TableCell>Chasis</TableCell>
                <TableCell>Colour</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Source</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filtered.map((bike) => (
                <TableRow key={bike._id}>
                  <TableCell>{bike.model}</TableCell>
                  <TableCell>{bike.engine}</TableCell>
                  <TableCell>{bike.chasis}</TableCell>
                  <TableCell>{bike.colour}</TableCell>
                  {/* <TableCell>{bike.purchasePrice}</TableCell> */}
                  <TableCell>{bike.status}</TableCell>
                  <TableCell>{bike.location}</TableCell>
                  <TableCell>{bike.source}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
};

export default FindBike;